import {Grid} from '@logistics-frontend/blocks'
import React from 'react'

import {Action, ActionType} from 'src/api/cargo-c2c/types'

import {CancelButton} from '../cancel-button'
import {PerformerBadge} from '../performer/PerformerBadge'
import {PerformerCall} from '../performer/PerformerCall'
import {SupportButton} from '../support-button'
import {UniversalLinkAction} from '../UniversalLinkAction'
import {classes} from './Actions.classes'

type ActionComponent = React.ComponentType<{action: Action}>

const actionComponentMap: Partial<Record<ActionType, ActionComponent>> = {
  show_support_web: SupportButton as ActionComponent,
  open_yandex_messenger_support_chat: SupportButton as ActionComponent,
  open_universal_link: UniversalLinkAction as ActionComponent,
  cancel_v2: CancelButton as ActionComponent,
  performer_call: PerformerCall as ActionComponent,
  performer_badge: PerformerBadge as ActionComponent,
}

type Props = {
  actions: Action[]
}

const Actions: React.FC<Props> = ({actions}) => {
  return (
    <Grid className={classes.section} justify="center" container>
      {actions.map(action => {
        const ActionComponent = actionComponentMap[action.type as ActionType]

        return ActionComponent ? (
          <Grid key={action.type} item>
            <ActionComponent action={action} />
          </Grid>
        ) : null
      })}
    </Grid>
  )
}

export default Actions
